import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

const initialState = {
  isLogged: false,
  user: null,
  role: null, // 'admin' or 'user'
};

const authSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.isLogged = true;
      state.user = action.payload;
    },
    setUserRole: (state, action) => {
      state.role = action.payload;
    },
    clearUser: state => {
      Cookies.remove("jwt_token");
      return initialState;
    },
  },
});

export const { setUser, setUserRole, clearUser } = authSlice.actions;

export default authSlice.reducer;
